import { toLower } from 'lodash';

export const formatTestId = (
  type: string,
  testId: string | null | undefined,
  suffix: string | string[] | null | undefined = null
): string =>
  [testId, type, ...(suffix && typeof suffix === 'object' ? suffix : [suffix])]
    .filter(option => option)
    .map(option => toLower(option!))
    .join('.');
